import { IWaypointMarker, WaypointMarkerType } from "../../../logic/api"

import START from './start.svg'
import END from './end.svg'
import ACCELERATING_1 from './Accelerating-1.svg'
import ACCELERATING_2 from './Accelerating-2.svg'
import ACCELERATING_3 from './Accelerating-3.svg'
import BRAKING_1 from './Braking-1.svg'
import BRAKING_2 from './Braking-2.svg'
import BRAKING_3 from './Braking-3.svg'
import CORNERING_1 from './Cornering-1.svg'
import CORNERING_2 from './Cornering-2.svg'
import CORNERING_3 from './Cornering-3.svg'
import SPEED_1 from './Speed-1.svg'
import SPEED_2 from './Speed-2.svg'
import SPEED_3 from './Speed-3.svg'


const FALLBACK_ICON = "https://www.google.com/mapfiles/marker.png"
const MARKER_ICON_STRENGTH_MAP = new Map([
  [WaypointMarkerType.ACCELERATION, new Map([
    [1, ACCELERATING_1],
    [2, ACCELERATING_2],
    [3, ACCELERATING_3]
  ])],
  [WaypointMarkerType.BRAKING, new Map([
    [1, BRAKING_1],
    [2, BRAKING_2],
    [3, BRAKING_3]
  ])],
  [WaypointMarkerType.CORNERING, new Map([
    [1, CORNERING_1],
    [2, CORNERING_2],
    [3, CORNERING_3]
  ])],
  [WaypointMarkerType.SPEEDING, new Map([
    [1, SPEED_1],
    [2, SPEED_2],
    [3, SPEED_3]
  ])],
  [WaypointMarkerType.UNKNOWN, new Map([
    [1, FALLBACK_ICON],
    [2, FALLBACK_ICON],
    [3, FALLBACK_ICON]
  ])]
])

export function getIcon(marker: IWaypointMarker): google.maps.Icon {
  let url = FALLBACK_ICON

  if (marker.type === WaypointMarkerType.START) {
    url = START
  } else if (marker.type === WaypointMarkerType.END) {
    url = END
  } else if (marker.strength) {
    const icons = MARKER_ICON_STRENGTH_MAP.get(marker.type)
    if (icons) {
      url = icons.get(marker.strength) || FALLBACK_ICON
    }
  }

  return {
    size: new google.maps.Size(32, 32),
    url
  }
}
